import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PaginationWrapper } from 'shs-pagination'

import * as MASKS from '../../utils/input-masks'

const mapStateToProps = (state) => {
    const paginator = state.paginator.adminChefs
    let chefs = state.adminChefs
    if (paginator) {
        chefs = chefs
            .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
            .sort((a, b) => {
                if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                    return 1
                }
                return -1
            })
    }

    return {
        chefs,
        paginator
    }
}

const ListChefs = ({ dispatch, chefs, paginator }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/chefs', 'LIST')))
    }, [dispatch])

    const renderChefRow = (chef, index) => {
        return (
            <tr key={chef.id}>
                <td><span>{index}.</span></td>
                <td>{chef.firstName}</td>
                <td>{chef.lastName}</td>
                <td>{chef.city}</td>
                <td>{chef.state}</td>
                <td><a href={`mailto:${chef.email}`}>{chef.email}</a></td>
                <td>{MASKS.phoneMask.resolve(chef.phone || '')}</td>
                <td>
                    <Link to={buildRoutePath(routes.adminChefProfileIndex.path, { chefId: chef.id })} title="View">
                        Manage
                    </Link>
                </td>
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/chefs', 'LIST'), paginationParams))
    }

    const renderChefs = () => {
        if (!paginator) {
            return null
        }
        let allChefs = []
        chefs.forEach((chef, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allChefs.push(renderChefRow(chef, index))
        })

        const controls = {
            search: {
                active: true,
                collapsed: true
            }
        }

        return (
            <PaginationWrapper
                paginator={paginator}
                data={chefs}
                controls={controls}
                callbackFX={handlePaginationUpdate}
                renderTemplate={renderChefRow}
                countOptions={[10, 25, 50, 100, 250]}>
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allChefs}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    const renderHeader = () => {
        return (
            <div className="section-header">
                <span className="title">All Chefs</span>
                <div className="pagination-controls">
                    <Link className="controls" to={routes.adminChefsCreate.path} title="Add Chef">
                        <FontAwesomeIcon icon="plus" /> &nbsp; New Chef
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <>
            {renderHeader()}
            {renderChefs()}
        </>
    )
}

export default connect(mapStateToProps)(ListChefs)
